import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskManagerComponent } from './task-manager.component';
import { TaskManagerButtonComponent } from './task-manager-button/task-manager-button.component';
import { SharedModule } from '../_shared/shared.module';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { LabelPipeModule } from '../_shared/label-pipe/label-pipe.module';
import { HistoryEventComponent } from './history-event/history-event.component';
import { LoaderComponent } from '../_core/components/loader/loader.component';

@NgModule({
  declarations: [
    TaskManagerComponent,
    TaskManagerButtonComponent,
    HistoryEventComponent,
  ],
  imports: [
    SharedModule,
    CdkDrag,
    OverlayModule,
    LabelPipeModule,
    LoaderComponent,
  ],
  exports: [TaskManagerComponent, TaskManagerButtonComponent],
})
export class TaskManagerModule {}
